module.exports = __webpack_public_path__ + "static/media/kcc-group.4059afd6.png";